module.exports = __webpack_public_path__ + "static/media/cementTruck_red.2089aaa5.svg";